<template>
  <div class="container flex-column flex-justify-start flex-align-center">
    <div class="submenu flex-row flex-justify-start flex-align-start" v-if="subindex<=3">
      <div class="sm-item" :class="[{'sm-item-sel': subindex==1}]" @click="changeSubindex(1)">能耗统计</div>
      <div class="sm-item" :class="[{'sm-item-sel': subindex==2}]" @click="changeSubindex(2)">能耗分析</div>
      <div class="sm-item" :class="[{'sm-item-sel': subindex==3}]" @click="changeSubindex(3)">维修分析</div>
    </div>
    <div class="data-monitor flex-row flex-justify-start flex-align-start" v-if="subindex==1">
      <div class="dataml flex-column flex-justify-start flex-align-center">
        <div class="dataml-title">楼宇</div>
        <div style="width: 100%;">
          <el-tree v-if="showTree" node-key="id" ref="treeRef" :expand-on-click-node="false" :default-expanded-keys="['1', '2']" :data="tongjipage.treeData" :props="{label: 'name', children: 'children'}" @node-click="handleNodeClick">
            <span slot-scope="{node}" @click="handleTreeClick(node.data)" class="flex-row flex-justify-start flex-align-start">
              <span class="tree-node" :class="[{'tree-node-sel': node.data.id==tongjipage.form.selectd}]">
                <span class="node-icon">
                  <i class="el-icon-folder" v-if="node.data.children && node.data.children.length" style="color: #f5a623;;"></i>
                  <i class="el-icon-document" v-else></i>
                </span>
                <span class="node-label">{{node.data.name}}</span>
              </span>
            </span>
          </el-tree>
        </div>
      </div>
      <div class="datamr flex-column flex-justify-start flex-align-center">
        <div class="flex-row flex-justify-start flex-align-start" style="width: 100%;">
          <div class="tjtype" :class="[{'tjtype-sel': tongjipage.tongjitype==1}]" @click="handleTongjiType(1)">日报统计</div>
          <div class="tjtype" :class="[{'tjtype-sel': tongjipage.tongjitype==2}]" @click="handleTongjiType(2)">月报统计</div>
        </div>
        <div class="datamr-s flex-row flex-justify-start flex-align-start">
          <div class="datamrs-s flex-wrap flex-justify-start flex-align-start">
            <div class="ds-item flex-row flex-justify-start flex-align-center">
              <div class="dsi-text">统计时间：</div>
              <el-date-picker
                v-model="tongjipage.selmonth"
                type="month"
                placeholder="选择日期"
                style="width: 250px"
                v-if="tongjipage.tongjitype==1">
              </el-date-picker>
              <el-date-picker
                v-model="tongjipage.selyear"
                type="year"
                placeholder="选择日期"
                style="width: 250px"
                v-else>
              </el-date-picker>
            </div>
            <div class="ds-item flex-row flex-justify-start flex-align-center">
              <div class="dsi-text">类别：</div>
              <el-select v-model="tongjipage.form.devtype" placeholder="请选择" style="width: 250px">
                <el-option
                  v-for="item in tongjipage.options.devtype"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="ds-item flex-row flex-justify-start flex-align-center">
              <el-button type="primary" icon="el-icon-search" style="font-size: 14px; padding: 11px;" @click="handleTongji">统计</el-button>
              <el-button type="primary" icon="el-icon-upload" style="font-size: 14px; padding: 11px;">打印</el-button>
            </div>
          </div>
        </div>
        <div class="datamr-d flex-column flex-justify-start flex-align-center">
          <div class="datamrdt">用电统计分析</div>
          <div class="gird-area" v-if="tongjipage.tongjitype==1">
            <el-table :data="tongjipage.tableData" :header-cell-style="{'text-align': 'center', 'background-color': '#f5fafe'}" :cell-style="{'text-align': 'center'}" border>
              <el-table-column prop="id" label="编号" width="200"></el-table-column>
              <el-table-column prop="name" label="表名" width="200"></el-table-column>
              <el-table-column prop="location" label="位置" width="200"></el-table-column>
              <el-table-column prop="day1" label="1日" width="100"></el-table-column>
              <el-table-column prop="day2" label="2日" width="100"></el-table-column>
              <el-table-column prop="day3" label="3日" width="100"></el-table-column>
              <el-table-column prop="day4" label="4日" width="100"></el-table-column>
              <el-table-column prop="day5" label="5日" width="100"></el-table-column>
              <el-table-column prop="day6" label="6日" width="100"></el-table-column>
              <el-table-column prop="day7" label="7日" width="100"></el-table-column>
              <el-table-column prop="day8" label="8日" width="100"></el-table-column>
              <el-table-column prop="day9" label="9日" width="100"></el-table-column>
              <el-table-column prop="day10" label="10日" width="100"></el-table-column>
              <el-table-column prop="day11" label="11日" width="100"></el-table-column>
              <el-table-column prop="day12" label="12日" width="100"></el-table-column>
              <el-table-column prop="day13" label="13日" width="100"></el-table-column>
              <el-table-column prop="day14" label="14日" width="100"></el-table-column>
              <el-table-column prop="day15" label="15日" width="100"></el-table-column>
              <el-table-column prop="day16" label="16日" width="100"></el-table-column>
              <el-table-column prop="day17" label="17日" width="100"></el-table-column>
              <el-table-column prop="day18" label="18日" width="100"></el-table-column>
              <el-table-column prop="day19" label="19日" width="100"></el-table-column>
              <el-table-column prop="day20" label="20日" width="100"></el-table-column>
              <el-table-column prop="day21" label="21日" width="100"></el-table-column>
              <el-table-column prop="day22" label="22日" width="100"></el-table-column>
              <el-table-column prop="day23" label="23日" width="100"></el-table-column>
              <el-table-column prop="day24" label="24日" width="100"></el-table-column>
              <el-table-column prop="day25" label="25日" width="100"></el-table-column>
              <el-table-column prop="day26" label="26日" width="100"></el-table-column>
              <el-table-column prop="day27" label="27日" width="100"></el-table-column>
              <el-table-column prop="day28" label="28日" width="100" v-if="tongjipage.monthdays>=28"></el-table-column>
              <el-table-column prop="day29" label="29日" width="100" v-if="tongjipage.monthdays>=29"></el-table-column>
              <el-table-column prop="day30" label="30日" width="100" v-if="tongjipage.monthdays>=30"></el-table-column>
              <el-table-column prop="day31" label="31日" width="100" v-if="tongjipage.monthdays>=31"></el-table-column>
            </el-table>
          </div>
          <div class="gird-area" v-else>
            <el-table :data="tongjipage.tableData" :header-cell-style="{'text-align': 'center', 'background-color': '#f5fafe'}" :cell-style="{'text-align': 'center'}" border>
              <el-table-column prop="id" label="编号" width="200"></el-table-column>
              <el-table-column prop="name" label="表名" width="200"></el-table-column>
              <el-table-column prop="location" label="位置" width="200"></el-table-column>
              <el-table-column prop="mon1" label="1月" width="100"></el-table-column>
              <el-table-column prop="mon2" label="2月" width="100"></el-table-column>
              <el-table-column prop="mon3" label="3月" width="100"></el-table-column>
              <el-table-column prop="mon4" label="4月" width="100"></el-table-column>
              <el-table-column prop="mon5" label="5月" width="100"></el-table-column>
              <el-table-column prop="mon6" label="6月" width="100"></el-table-column>
              <el-table-column prop="mon7" label="7月" width="100"></el-table-column>
              <el-table-column prop="mon8" label="8月" width="100"></el-table-column>
              <el-table-column prop="mon9" label="9月" width="100"></el-table-column>
              <el-table-column prop="mon10" label="10月" width="100"></el-table-column>
              <el-table-column prop="mon11" label="11月" width="100"></el-table-column>
              <el-table-column prop="mon12" label="12月" width="100"></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <div class="flex-column flex-justify-start flex-align-start" v-if="subindex==2" style="width: 99%;">
      <div class="data-search flex-wrap flex-justify-start flex-align-start">
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">开始日期：</div>
          <el-date-picker
            v-model="nenghaopage.starttime"
            type="date"
            placeholder="选择日期"
            style="width: 250px">
          </el-date-picker>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">结束日期：</div>
          <el-date-picker
            v-model="nenghaopage.endtime"
            type="date"
            placeholder="选择日期"
            style="width: 250px">
          </el-date-picker>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <el-button type="primary" style="font-size: 14px; padding: 11px;" @click="handleFenxi">开始分析</el-button>
        </div>
      </div>
      <div class="nh-title">园区能耗分析 {{ nenghaopage.form.starttime }}--{{ nenghaopage.form.endtime }}</div>
      <div class="flex-row flex-justify-start flex-align-start" style="width: 100%;">
        <NhChart :gap="true" :charttype="1" :timedate="nenghaopage.form" :initdone="nenghaopage.initdone"></NhChart>
        <NhChart :gap="true" :charttype="2" :timedate="nenghaopage.form" :initdone="nenghaopage.initdone"></NhChart>
        <NhChart :gap="false" :charttype="3" :timedate="nenghaopage.form" :initdone="nenghaopage.initdone"></NhChart>
      </div>
    </div>
    <div class="flex-column flex-justify-start flex-align-start" v-if="subindex==3" style="width: 99%;">
      <div class="data-search flex-wrap flex-justify-start flex-align-start">
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">开始日期：</div>
          <el-date-picker
            v-model="weixiupage.starttime"
            type="date"
            placeholder="选择日期"
            style="width: 250px">
          </el-date-picker>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">结束日期：</div>
          <el-date-picker
            v-model="weixiupage.endtime"
            type="date"
            placeholder="选择日期"
            style="width: 250px">
          </el-date-picker>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <el-button type="primary" style="font-size: 14px; padding: 11px;" @click="handleWeixiu">开始分析</el-button>
        </div>
      </div>
      <div class="flex-row flex-justify-start flex-align-start" style="width: 100%;">
        <WxChart :timedate="weixiupage.form" :initdone="weixiupage.initdone"></WxChart>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import {getMapTree, getDayReport, getMonReport} from '@/api/engery.js'
import NhChart from '@/views/Home/engery/NhChart.vue'
import WxChart from '@/views/Home/engery/WxChart.vue'

export default {
  name: 'EngeryStatistics',
  components: {
    NhChart,
    WxChart
  },
  data() {
    return {
      subindex: 1,
      lastsubindex: 1,
      showTree: false,
      tongjipage: {
        options: {
          devtype: [
            {
              value: '电表',
              label: '电表'
            },
            {
              value: '水表',
              label: '水表'
            },
            {
              value: '冷气表',
              label: '冷气表'
            },
            {
              value: '流量计',
              label: '流量计'
            }
          ],
        },
        form: {
          selectd: '',
          devtype: '电表',
          seldate: '',
          changqu: '',
          louhao: '',
          louceng: ''
        },
        selmonth: null,
        selyear: null,
        monthdays: 0,
        tongjitype: 1,
        treeData: [],
        tableData: []
      },
      nenghaopage: {
        form: {
          starttime: '',
          endtime: ''
        },
        initdone: false,
        starttime: null,
        endtime: null
      },
      weixiupage: {
        form: {
          starttime: '',
          endtime: ''
        },
        initdone: false,
        starttime: null,
        endtime: null
      }
    }
  },
  async mounted() {
    // 统计分析页面变量
    const treeDataList = await getMapTree()
    this.tongjipage.treeData = treeDataList.data
    this.showTree = true
    const padZero = n => n < 10 ? `0${n}` : n
    const now = new Date()
    let year = now.getFullYear()
    let month = now.getMonth() + 1
    let day = now.getDate()
    const month1 = padZero(month)
    this.tongjipage.form.seldate = `${year}-${month1}`
    this.tongjipage.selmonth = new Date(`${year}-${month1}`)
    this.tongjipage.selyear = new Date(`${year}`)
    this.tongjipage.monthdays = new Date(year, month, 0).getDate()
    const tableDataList = await getDayReport(this.tongjipage.form)
    this.tongjipage.tableData = tableDataList.data
    // 能耗分析页面变量
    month = month - 1
    if(month == 0) {
      year = year - 1
      month = 12
    }
    const month2 = padZero(month)
    const day1 = padZero(day)
    this.nenghaopage.form.starttime = `${year}-${month2}-${day1}`
    this.nenghaopage.form.endtime = `${year}-${month1}-${day1}`
    this.nenghaopage.starttime = new Date(this.nenghaopage.form.starttime)
    this.nenghaopage.endtime = new Date(this.nenghaopage.form.endtime)
    // 维修分析页面
    this.weixiupage.form.endtime = `${year}-${month1}-${day1}`
    now.setDate(now.getDate() - 7)
    year = now.getFullYear()
    month = now.getMonth() + 1
    const month3 = padZero(month)
    day = now.getDate()
    const day2 = padZero(day)
    this.weixiupage.form.starttime = `${year}-${month3}-${day2}`
    this.weixiupage.starttime = new Date(this.weixiupage.form.starttime)
    this.weixiupage.endtime = new Date(this.weixiupage.form.endtime)
  },
  methods: {
    changeSubindex(index) {
      this.lastsubindex = this.subindex
      this.subindex = index
      if(index == 2){
        setTimeout(() => {
          this.nenghaopage.initdone = !this.nenghaopage.initdone
        }, 500)
      } else if(index == 3) {
        setTimeout(() => {
          this.weixiupage.initdone = !this.weixiupage.initdone
        }, 500)
      }
    },
    handleWeixiu() {
      const padZero = n => n < 10 ? `0${n}` : n
      let date = this.weixiupage.starttime
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let month1 = padZero(month)
      let day = date.getDate()
      let days = padZero(day)
      this.weixiupage.form.starttime = `${year}-${month1}-${days}`
      date = this.weixiupage.endtime
      year = date.getFullYear()
      month = date.getMonth() + 1
      month1 = padZero(month)
      day = date.getDate()
      days = padZero(day)
      this.weixiupage.form.endtime = `${year}-${month1}-${days}`
      this.weixiupage.initdone = !this.weixiupage.initdone
  },
    handleFenxi() {
      const padZero = n => n < 10 ? `0${n}` : n
      let date = this.nenghaopage.starttime
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let month1 = padZero(month)
      let day = date.getDate()
      let days = padZero(day)
      this.nenghaopage.form.starttime = `${year}-${month1}-${days}`
      date = this.nenghaopage.endtime
      year = date.getFullYear()
      month = date.getMonth() + 1
      month1 = padZero(month)
      day = date.getDate()
      days = padZero(day)
      this.nenghaopage.form.endtime = `${year}-${month1}-${days}`
      this.nenghaopage.initdone = !this.nenghaopage.initdone
    },
    handleTreeClick(param) {
      this.tongjipage.form.selectd = param.id
    },
    handleNodeClick(clickNode) {
      const currentNode = this.$refs.treeRef.getNode(clickNode.id)
      const path = []
      let tempNode = currentNode
      while(tempNode) {
        path.unshift(tempNode.data)
        tempNode = tempNode.parent
      }
      const fullPath = path.filter(item => item.name)
      if(fullPath[0]) {
        this.tongjipage.form.changqu = fullPath[0].name
      } else {
        this.tongjipage.form.changqu = ''
      }
      if(fullPath[1]) {
        this.tongjipage.form.louhao = fullPath[1].name
      } else {
        this.tongjipage.form.louhao = ''
      }
      if(fullPath[2]) {
        this.tongjipage.form.louceng = fullPath[2].name
      } else {
        this.tongjipage.form.louceng = ''
      }
    },
    async handleTongji() {
      const padZero = n => n < 10 ? `0${n}` : n
      const date = this.tongjipage.selmonth
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const month1 = padZero(month)
      this.tongjipage.form.seldate = `${year}-${month1}`
      this.tongjipage.monthdays = new Date(year, month, 0).getDate()
      const tableDataList = await getDayReport(this.tongjipage.form)
      this.tongjipage.tableData = tableDataList.data
    },
    async handleTongjiType(value) {
      const padZero = n => n < 10 ? `0${n}` : n
      this.tongjipage.tongjitype = value
      if(value == 1) {
        this.tongjipage.tableData = []
        const date = this.tongjipage.selmonth
        const year = date.getFullYear()
        const month = date.getMonth() + 1
        const month1 = padZero(month)
        this.tongjipage.form.seldate = `${year}-${month1}`
        this.tongjipage.monthdays = new Date(year, month, 0).getDate()
        const tableDataList = await getDayReport(this.tongjipage.form)
        this.tongjipage.tableData = tableDataList.data
      } else {
        this.tongjipage.tableData = []
        const date = this.tongjipage.selyear
        const year = date.getFullYear()
        this.tongjipage.form.seldate = `${year}`
        const tableDataList = await getMonReport(this.tongjipage.form)
        this.tongjipage.tableData = tableDataList.data
      }
    }
  }
}
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
}
.submenu {
  width: 99%;
  margin-top: 10px;
  background-color: #fff;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.4);
}
.sm-item {
  font-family: 'Arial';
  font-size: 18px;
  padding: 10px;
  margin-left: 20px;
}
.sm-item:hover {
  cursor: pointer;
}
.sm-item-sel {
  border-bottom-width: 2px;
  border-bottom-style: solid;
  border-bottom-color: #4660b6;
  color: #4660b6;
}
.data-monitor {
  margin-top: 20px;
  width: 99%;
}
.dataml {
  height: 936px;
  width: 14%;
  margin-right: 1%;
  margin-bottom: 20px;
  padding-bottom: 20px;
  background-color: #fff;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.4);
}
.dataml-title {
  color: #1890ff;
  width: 100%;
  font-family: 'Arial';
  font-size: 20px;
  font-weight: bold;
  text-align: left;
  margin-top: 10px;
  padding-left: 10px;
  margin-bottom: 10px;
}
.tree-node {
  gap: 5px;
  font-size: 13px;
  overflow: hidden;
  padding-left: 5px;
  padding-right: 5px;
}
.tree-node-sel {
  background-color: #ffebc0;
}
.node-icon {
  font-size: 14px;
  flex-shrink: 0;
  padding-right: 5px;
}
.node-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tjtype {
  padding-top: 5px;
  padding-bottom: 5px;
  margin-right: 5px;
  padding-left: 10px;
  padding-right: 10px;
  font-family: 'Arial';
  font-size: 18px;
  background-color: #e3e3e3;
  border-radius: 5px;
  cursor: pointer;
}
.tjtype-sel {
  color: #fff;
  background-color: #1890ff;
}
.datamr {
  width: 85%;
}
.datamr-s {
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.4);
}
.datamr-d {
  margin-top: 10px;
  margin-bottom: 20px;
  width: 100%;
  height: 800px;
  background-color: #fff;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.4);
}
.datamrdt {
  width: 100%;
  text-align: center;
  font-family: 'Arial';
  font-size: 20px;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 10px;
}
.datamrs-s {
  margin-top: 20px;
  margin-bottom: 20px;
  width: 98%;
}
.ds-item {
  margin-left: 20px;
  margin-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
}
.dsi-text {
  font-family: 'Arial';
  font-size: 16px;
  min-width: 140px;
  text-align: left;
}
.gird-area {
  margin-top: 20px;
  margin-bottom: 20px;
  width: 98%;
}
.data-search {
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.4);
  padding-top: 10px;
  padding-bottom: 10px;
  margin-top: 10px;
}
.ds-item {
  margin-left: 20px;
  margin-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
}
.dsi-text {
  font-family: 'Arial';
  font-size: 16px;
  min-width: 140px;
  text-align: left;
}
.nh-title {
  width: 100%;
  margin-top: 10px;
  text-align: center;
  font-family: 'Arial';
  font-size: 24px;
  font-weight: bold;
}
</style>
